<template>
  <v-container v-if="rooms && sales && occupancies" fluid>

    <im-page-title
      title="Statistici"
    />

    <im-statistics-toolbar
      class="ma-3"
      :from.sync="interval.from"
      :until.sync="interval.until"
    />

    <div class="ma-3 my-2 mt-n1">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <v-row no-gutters class="pa-2 mt-n3">
      <v-col cols="12">
        <im-sales-day-chart class="ma-1" :sales="sales"/>
      </v-col>
      <v-col cols="3">
        <im-sales-room-chart class="ma-1" :sales="sales" :rooms="rooms"/>
      </v-col>
      <v-col cols="3">
        <im-sales-rate-chart class="ma-1" :sales="sales" :rates="rates"/>
      </v-col>
      <v-col cols="6">
        <im-sales-vs-costs-chart class="ma-1" :sales="sales" :rooms="rooms"/>
      </v-col>
      <v-col cols="12">
        <im-occupancies-chart class="ma-1" :occupancies="occupancies"/>
      </v-col>
      <v-col cols="4" v-for="room in rooms">
        <im-occupancies-room-chart class="ma-1" :occupancies="occupancies" :room="room"/>
      </v-col>
    </v-row>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import room_repository from '@/repositories/room-repository';
  import rate_repository from '@/repositories/rate-repository';
  import statistics_repository from '@/repositories/statistics-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-statistics-toolbar': () => import('@/components/Statistics/StatisticsToolbar'),
      'im-sales-day-chart': () => import('@/components/Statistics/SalesChart'),
      'im-sales-room-chart': () => import('@/components/Statistics/SalesRoomChart'),
      'im-sales-rate-chart': () => import('@/components/Statistics/SalesRateChart'),
      'im-sales-vs-costs-chart': () => import('@/components/Statistics/SalesCostsChart'),
      'im-occupancies-chart': () => import('@/components/Statistics/OccupanciesChart'),
      'im-occupancies-room-chart': () => import('@/components/Statistics/OccupanciesRoomChart')
    },

    data() {
      return {
        querying: false,
        interval: {
          from: this.$moment().format('YYYY-MM-DD'),
          until: this.$moment().add(7, 'days').format('YYYY-MM-DD')
        },
        rooms: null,
        rates: null,
        sales: null,
        occupancies: null
      }
    },

    watch: {
      interval: {
        handler: 'getHotelStatistics',
        immediate: true,
        deep: true
      }
    },

    methods: {
      async getHotelStatistics() {
        try {
          this.querying = true;
          this.rooms = await room_repository.getRooms(this.$route.params.hotel, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true});
          this.rates = await rate_repository.getRates(this.$route.params.hotel, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true});
          this.sales = await statistics_repository.getSaleStats(this.$route.params.hotel, this.interval);
          this.occupancies = await statistics_repository.getOccupancyStats(this.$route.params.hotel, this.interval);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.querying = false;
        }
      }
    }

  }

</script>